import React, { useEffect, useState } from 'react';
import api from '../../api/axios';
import { Container, Row, Col } from 'react-bootstrap';
import MesaCardCobro from '../../components/Cajero/MesaCardCobro';

const CobrarMesasView = () => {
  const [mesas, setMesas] = useState([]);
  const business = JSON.parse(localStorage.getItem('business'));

  const fetchMesas = async () => {
    try {
      const res = await api.get('/mesas', {
        params: { business_id: business.id }
      });
      const mesasParaCobrar = res.data.filter((m) => m.status === 'para_cobrar');
      setMesas(mesasParaCobrar);
    } catch (err) {
      console.error('Error al traer mesas:', err);
    }
  };

  useEffect(() => {
    fetchMesas();
  }, []);

  return (
    <Container fluid className="p-4">
      {/* <h2 className="mb-4">💵 Mesas para cobrar</h2> */}
      <Row>
        {mesas.length === 0 ? (
          <p>No hay mesas para cobrar.</p>
        ) : (
          mesas.map((mesa) => (
            <Col key={mesa.id} xs={12} sm={6} md={4} lg={3} className="d-flex">
              <MesaCardCobro mesa={mesa} onRefresh={fetchMesas} />
            </Col>
          ))
        )}
      </Row>
    </Container>
  );
};

export default CobrarMesasView;
